import * as React from 'react'
import {fromMaybe} from '@freckle/maybe'

type Props = {
  name: string
  value: React.ReactNode | undefined | null
}

export default function LabelWithValue(props: Props): React.ReactElement {
  const {name, value} = props

  const valueToDisplay = fromMaybe(() => 'None', value)
  return (
    <div className="flex items-baseline gap-3 py-1">
      <span className="text-xs font-semibold text-muted-text uppercase tracking-wide w-40 shrink-0">
        {name}:
      </span>
      <span className="text-sm text-body">{valueToDisplay}</span>
    </div>
  )
}
